// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: configd/design.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { DesignNodeData } from "../models/cabling";
import {
  DiscoveredTopology,
  FabricDesign,
  HwSet,
  NodePortConnectivityRule,
  NodePortOverrideRule,
  RailGroup,
  ServerGroup,
  ServerGroupConnectivityRule,
  SwitchGroup,
  SwitchGroupConnectivityRule,
  Tier,
} from "../models/fabric_design";

export const protobufPackage = "configd";

export interface TiersResponse {
  /** The fabric id for the tier. */
  fabricId: string;
  /** The fabric name. */
  fabricName: string;
  /** The tiers for the fabric. */
  tiers: Tier[];
}

export interface GetTiersRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The fabric candidate name. */
  candidate: string;
}

export interface GetTierRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The tier id or name. */
  tierId: string;
  /** The fabric candidate name. */
  candidate: string;
}

export interface AddTiersRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The new tiers to be added. */
  tiers: Tier[];
}

export interface UpdateTierRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The tier id or name. */
  tierId: string;
  /** The new tier definition. */
  tier: Tier | undefined;
}

export interface DeleteTierRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The tier id or name. */
  tierId: string;
}

export interface SwitchGroupsResponse {
  /** The fabric id for the tier. */
  fabricId: string;
  /** The fabric name. */
  fabricName: string;
  /** The tier id for this group. */
  tierId: string;
  /** The tier name for this group. */
  tierName: string;
  /** The switch groups. */
  groups: SwitchGroup[];
}

export interface GetSwitchGroupsRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The tier id or name. */
  tierId: string;
  /** The fabric candidate name. */
  candidate: string;
}

export interface GetSwitchGroupRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The tier id or name. */
  tierId: string;
  /** The switch group id or name. */
  groupId: string;
  /** The fabric candidate name. */
  candidate: string;
}

export interface AddSwitchGroupsRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The tier id or name. */
  tierId: string;
  /** The new tiers to be added. */
  groups: SwitchGroup[];
}

export interface UpdateSwitchGroupRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The tier id or name. */
  tierId: string;
  /** The switch group id or name. */
  groupId: string;
  /** The new tier definition. */
  group: SwitchGroup | undefined;
}

export interface DeleteSwitchGroupRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The tier id or name. */
  tierId: string;
  /** The switch group id or name. */
  groupId: string;
}

export interface SwitchGroupHardwareSetsResponse {
  sets: HwSet[];
}

export interface GetSwitchGroupHardwareSetsRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The tier id or name. */
  tierId: string;
  /** The switch group id or name. */
  groupId: string;
  /** The fabric candidate name. */
  candidate: string;
}

export interface GetSwitchGroupHardwareSetRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The tier id or name. */
  tierId: string;
  /** The switch group id or name. */
  groupId: string;
  /** The hardware set id or name. */
  setId: string;
  /** The fabric candidate name. */
  candidate: string;
}

export interface AddSwitchGroupHardwareSetsRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The tier id or name. */
  tierId: string;
  /** The switch group id or name. */
  groupId: string;
  /** The new hardware sets to be added. */
  sets: HwSet[];
}

export interface UpdateSwitchGroupHardwareSetRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The tier id or name. */
  tierId: string;
  /** The switch group id or name. */
  groupId: string;
  /** The hardware set id or name. */
  setId: string;
  /** The new tier definition. */
  set: HwSet | undefined;
}

export interface DeleteSwitchGroupHardwareSetRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The tier id or name. */
  tierId: string;
  /** The switch group id or name. */
  groupId: string;
  /** The hardware set id or name. */
  setId: string;
}

export interface ServerGroupsResponse {
  /** The fabric id for the tier. */
  fabricId: string;
  /** The fabric name. */
  fabricName: string;
  /** The tier id for this group. */
  tierId: string;
  /** The tier name for this group. */
  tierName: string;
  /** The server groups. */
  groups: ServerGroup[];
}

export interface GetServerGroupsRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The tier id or name. */
  tierId: string;
  /** The fabric candidate name. */
  candidate: string;
}

export interface GetServerGroupRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The tier id or name. */
  tierId: string;
  /** The server group id or name. */
  groupId: string;
  /** The fabric candidate name. */
  candidate: string;
}

export interface AddServerGroupsRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The tier id or name. */
  tierId: string;
  /** The new tiers to be added. */
  groups: ServerGroup[];
}

export interface UpdateServerGroupRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The tier id or name. */
  tierId: string;
  /** The server group id or name. */
  groupId: string;
  /** The new tier definition. */
  group: ServerGroup | undefined;
}

export interface DeleteServerGroupRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The tier id or name. */
  tierId: string;
  /** The server group id or name. */
  groupId: string;
}

export interface ServerGroupHardwareSetsResponse {
  sets: HwSet[];
}

export interface GetServerGroupHardwareSetsRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The tier id or name. */
  tierId: string;
  /** The server group id or name. */
  groupId: string;
  /** The fabric candidate name. */
  candidate: string;
}

export interface GetServerGroupHardwareSetRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The tier id or name. */
  tierId: string;
  /** The server group id or name. */
  groupId: string;
  /** The hardware set id or name. */
  setId: string;
  /** The fabric candidate name. */
  candidate: string;
}

export interface AddServerGroupHardwareSetsRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The tier id or name. */
  tierId: string;
  /** The server group id or name. */
  groupId: string;
  /** The new hardware sets to be added. */
  sets: HwSet[];
}

export interface UpdateServerGroupHardwareSetRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The tier id or name. */
  tierId: string;
  /** The server group id or name. */
  groupId: string;
  /** The hardware set id or name. */
  setId: string;
  /** The new hardware set definition. */
  set: HwSet | undefined;
}

export interface DeleteServerGroupHardwareSetRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The tier id or name. */
  tierId: string;
  /** The server group id or name. */
  groupId: string;
  /** The hardware set id or name. */
  setId: string;
}

export interface RailGroupsResponse {
  groups: RailGroup[];
}

export interface GetRailGroupsRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The fabric candidate name. */
  candidate: string;
}

export interface GetRailGroupRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The rail group id or name. */
  groupId: string;
  /** The fabric candidate name. */
  candidate: string;
}

export interface AddRailGroupsRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The new rail groups to be added. */
  groups: RailGroup[];
}

export interface UpdateRailGroupRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The rail group id or name. */
  groupId: string;
  /** The new rail group definition. */
  group: RailGroup | undefined;
}

export interface DeleteRailGroupRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The rail group id or name. */
  groupId: string;
}

export interface ServerGroupConnectivityRulesResponse {
  rules: ServerGroupConnectivityRule[];
}

export interface GetServerGroupConnectivityRulesRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The fabric candidate name. */
  candidate: string;
}

export interface GetServerGroupConnectivityRuleRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The connectivity rule id or name. */
  ruleId: string;
  /** The fabric candidate name. */
  candidate: string;
}

export interface AddServerGroupConnectivityRulesRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The new connectivity rules to be added. */
  rules: ServerGroupConnectivityRule[];
}

export interface UpdateServerGroupConnectivityRuleRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The connectivity rule id or name. */
  ruleId: string;
  /** The updated rule. */
  rule: ServerGroupConnectivityRule | undefined;
}

export interface DeleteServerGroupConnectivityRuleRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The connectivity rule id or name. */
  ruleId: string;
}

export interface SwitchGroupConnectivityRulesResponse {
  rules: SwitchGroupConnectivityRule[];
}

export interface GetSwitchGroupConnectivityRulesRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The fabric candidate name. */
  candidate: string;
}

export interface GetSwitchGroupConnectivityRuleRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The connectivity rules or name. */
  ruleId: string;
  /** The fabric candidate name. */
  candidate: string;
}

export interface AddSwitchGroupConnectivityRulesRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The new connectivity rules to be added. */
  rules: SwitchGroupConnectivityRule[];
}

export interface UpdateSwitchGroupConnectivityRuleRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The connectivity rules or name. */
  ruleId: string;
  /** The updated rule. */
  rule: SwitchGroupConnectivityRule | undefined;
}

export interface DeleteSwitchGroupConnectivityRuleRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The connectivity rule id or name. */
  ruleId: string;
}

export interface OverridesResponse {
  rules: NodePortConnectivityRule[];
}

export interface GetOverridesRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The fabric candidate name. */
  candidate: string;
}

export interface GetConnectionOverrideRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The connection override rule id or name. */
  ruleId: string;
  /** The fabric candidate name. */
  candidate: string;
}

export interface AddConnectionOverridesRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The new connection override rules to be added. */
  rules: NodePortConnectivityRule[];
}

export interface UpdateConnectionOverrideRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The override rule id or name. */
  ruleId: string;
  /** The updated rule. */
  rule: NodePortConnectivityRule | undefined;
}

export interface DeleteConnectionOverrideRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The override rule id or name. */
  ruleId: string;
}

export interface PortReservationsResponse {
  rules: NodePortOverrideRule[];
}

export interface GetPortReservationsRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The fabric candidate name. */
  candidate: string;
}

export interface GetPortReservationRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The port reservation rule id or name. */
  ruleId: string;
  /** The fabric candidate name. */
  candidate: string;
}

export interface AddPortReservationsRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The new port reservation rules to be added. */
  rules: NodePortOverrideRule[];
}

export interface UpdatePortReservationRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The port reservation rule id or name. */
  ruleId: string;
  /** The updated rule. */
  rule: NodePortOverrideRule | undefined;
}

export interface DeletePortReservationRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The port reservation rule id or name. */
  ruleId: string;
}

/**
 * MergeTopologyIntoFabricDesignRequest is the input for the stateless,
 * in-memory converter that merges a discovered topology into an existing
 * FabricDesign and returns the merged result.
 */
export interface MergeTopologyIntoFabricDesignRequest {
  /** The fabric this topology belongs to. */
  fabricId: string;
  /**
   * The existing fabric design to merge into.
   * For a brand-new fabric this may be empty.
   */
  design:
    | FabricDesign
    | undefined;
  /** The discovered topology to merge into the design. */
  topology:
    | DiscoveredTopology
    | undefined;
  /**
   * The fabric name for creating a new fabric design.
   * Required by the MergeTopologyIntoNewFabricDesign endpoint.
   * Must be unique within the organization.
   */
  fabricName: string;
}

/**
 * MergeTopologyIntoFabricDesignResponse contains the merged fabric design
 * and the list of discovered node-device bindings.
 */
export interface MergeTopologyIntoFabricDesignResponse {
  /** The merged fabric design. */
  design:
    | FabricDesign
    | undefined;
  /**
   * Node-device bindings for nodes added from the discovered topology.
   * Missing devices are excluded from this list.
   */
  discoveredNodeDeviceBindings: DesignNodeData[];
}

/**
 * ResolveTopologyRequest resolves a DiscoveredTopology from an existing
 * FabricDesign (and, in the future, an existing topology) so it can be
 * displayed in the topology discovery UI or used as a starting point for
 * incremental discovery.
 */
export interface ResolveTopologyRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The existing fabric design to convert. */
  design: FabricDesign | undefined;
}

/** ResolveTopologyResponse contains the resolved topology. */
export interface ResolveTopologyResponse {
  /** The topology resolved from the fabric design. */
  topology: DiscoveredTopology | undefined;
}

function createBaseTiersResponse(): TiersResponse {
  return { fabricId: "", fabricName: "", tiers: [] };
}

export const TiersResponse: MessageFns<TiersResponse> = {
  encode(message: TiersResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.fabricName !== "") {
      writer.uint32(18).string(message.fabricName);
    }
    for (const v of message.tiers) {
      Tier.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TiersResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTiersResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tiers.push(Tier.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TiersResponse {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      fabricName: isSet(object.fabricName) ? globalThis.String(object.fabricName) : "",
      tiers: globalThis.Array.isArray(object?.tiers) ? object.tiers.map((e: any) => Tier.fromJSON(e)) : [],
    };
  },

  toJSON(message: TiersResponse): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.fabricName !== "") {
      obj.fabricName = message.fabricName;
    }
    if (message.tiers?.length) {
      obj.tiers = message.tiers.map((e) => Tier.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TiersResponse>, I>>(base?: I): TiersResponse {
    return TiersResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TiersResponse>, I>>(object: I): TiersResponse {
    const message = createBaseTiersResponse();
    message.fabricId = object.fabricId ?? "";
    message.fabricName = object.fabricName ?? "";
    message.tiers = object.tiers?.map((e) => Tier.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetTiersRequest(): GetTiersRequest {
  return { fabricId: "", candidate: "" };
}

export const GetTiersRequest: MessageFns<GetTiersRequest> = {
  encode(message: GetTiersRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.candidate !== "") {
      writer.uint32(18).string(message.candidate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTiersRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTiersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTiersRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
    };
  },

  toJSON(message: GetTiersRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetTiersRequest>, I>>(base?: I): GetTiersRequest {
    return GetTiersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetTiersRequest>, I>>(object: I): GetTiersRequest {
    const message = createBaseGetTiersRequest();
    message.fabricId = object.fabricId ?? "";
    message.candidate = object.candidate ?? "";
    return message;
  },
};

function createBaseGetTierRequest(): GetTierRequest {
  return { fabricId: "", tierId: "", candidate: "" };
}

export const GetTierRequest: MessageFns<GetTierRequest> = {
  encode(message: GetTierRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.tierId !== "") {
      writer.uint32(18).string(message.tierId);
    }
    if (message.candidate !== "") {
      writer.uint32(26).string(message.candidate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTierRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTierRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTierRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      tierId: isSet(object.tierId) ? globalThis.String(object.tierId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
    };
  },

  toJSON(message: GetTierRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetTierRequest>, I>>(base?: I): GetTierRequest {
    return GetTierRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetTierRequest>, I>>(object: I): GetTierRequest {
    const message = createBaseGetTierRequest();
    message.fabricId = object.fabricId ?? "";
    message.tierId = object.tierId ?? "";
    message.candidate = object.candidate ?? "";
    return message;
  },
};

function createBaseAddTiersRequest(): AddTiersRequest {
  return { fabricId: "", tiers: [] };
}

export const AddTiersRequest: MessageFns<AddTiersRequest> = {
  encode(message: AddTiersRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    for (const v of message.tiers) {
      Tier.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddTiersRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddTiersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tiers.push(Tier.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddTiersRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      tiers: globalThis.Array.isArray(object?.tiers) ? object.tiers.map((e: any) => Tier.fromJSON(e)) : [],
    };
  },

  toJSON(message: AddTiersRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.tiers?.length) {
      obj.tiers = message.tiers.map((e) => Tier.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddTiersRequest>, I>>(base?: I): AddTiersRequest {
    return AddTiersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddTiersRequest>, I>>(object: I): AddTiersRequest {
    const message = createBaseAddTiersRequest();
    message.fabricId = object.fabricId ?? "";
    message.tiers = object.tiers?.map((e) => Tier.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpdateTierRequest(): UpdateTierRequest {
  return { fabricId: "", tierId: "", tier: undefined };
}

export const UpdateTierRequest: MessageFns<UpdateTierRequest> = {
  encode(message: UpdateTierRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.tierId !== "") {
      writer.uint32(18).string(message.tierId);
    }
    if (message.tier !== undefined) {
      Tier.encode(message.tier, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateTierRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateTierRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tier = Tier.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateTierRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      tierId: isSet(object.tierId) ? globalThis.String(object.tierId) : "",
      tier: isSet(object.tier) ? Tier.fromJSON(object.tier) : undefined,
    };
  },

  toJSON(message: UpdateTierRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.tier !== undefined) {
      obj.tier = Tier.toJSON(message.tier);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateTierRequest>, I>>(base?: I): UpdateTierRequest {
    return UpdateTierRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateTierRequest>, I>>(object: I): UpdateTierRequest {
    const message = createBaseUpdateTierRequest();
    message.fabricId = object.fabricId ?? "";
    message.tierId = object.tierId ?? "";
    message.tier = (object.tier !== undefined && object.tier !== null) ? Tier.fromPartial(object.tier) : undefined;
    return message;
  },
};

function createBaseDeleteTierRequest(): DeleteTierRequest {
  return { fabricId: "", tierId: "" };
}

export const DeleteTierRequest: MessageFns<DeleteTierRequest> = {
  encode(message: DeleteTierRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.tierId !== "") {
      writer.uint32(18).string(message.tierId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteTierRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteTierRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteTierRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      tierId: isSet(object.tierId) ? globalThis.String(object.tierId) : "",
    };
  },

  toJSON(message: DeleteTierRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteTierRequest>, I>>(base?: I): DeleteTierRequest {
    return DeleteTierRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteTierRequest>, I>>(object: I): DeleteTierRequest {
    const message = createBaseDeleteTierRequest();
    message.fabricId = object.fabricId ?? "";
    message.tierId = object.tierId ?? "";
    return message;
  },
};

function createBaseSwitchGroupsResponse(): SwitchGroupsResponse {
  return { fabricId: "", fabricName: "", tierId: "", tierName: "", groups: [] };
}

export const SwitchGroupsResponse: MessageFns<SwitchGroupsResponse> = {
  encode(message: SwitchGroupsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.fabricName !== "") {
      writer.uint32(18).string(message.fabricName);
    }
    if (message.tierId !== "") {
      writer.uint32(26).string(message.tierId);
    }
    if (message.tierName !== "") {
      writer.uint32(34).string(message.tierName);
    }
    for (const v of message.groups) {
      SwitchGroup.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SwitchGroupsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSwitchGroupsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.tierName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.groups.push(SwitchGroup.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SwitchGroupsResponse {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      fabricName: isSet(object.fabricName) ? globalThis.String(object.fabricName) : "",
      tierId: isSet(object.tierId) ? globalThis.String(object.tierId) : "",
      tierName: isSet(object.tierName) ? globalThis.String(object.tierName) : "",
      groups: globalThis.Array.isArray(object?.groups) ? object.groups.map((e: any) => SwitchGroup.fromJSON(e)) : [],
    };
  },

  toJSON(message: SwitchGroupsResponse): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.fabricName !== "") {
      obj.fabricName = message.fabricName;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.tierName !== "") {
      obj.tierName = message.tierName;
    }
    if (message.groups?.length) {
      obj.groups = message.groups.map((e) => SwitchGroup.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SwitchGroupsResponse>, I>>(base?: I): SwitchGroupsResponse {
    return SwitchGroupsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SwitchGroupsResponse>, I>>(object: I): SwitchGroupsResponse {
    const message = createBaseSwitchGroupsResponse();
    message.fabricId = object.fabricId ?? "";
    message.fabricName = object.fabricName ?? "";
    message.tierId = object.tierId ?? "";
    message.tierName = object.tierName ?? "";
    message.groups = object.groups?.map((e) => SwitchGroup.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetSwitchGroupsRequest(): GetSwitchGroupsRequest {
  return { fabricId: "", tierId: "", candidate: "" };
}

export const GetSwitchGroupsRequest: MessageFns<GetSwitchGroupsRequest> = {
  encode(message: GetSwitchGroupsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.tierId !== "") {
      writer.uint32(18).string(message.tierId);
    }
    if (message.candidate !== "") {
      writer.uint32(26).string(message.candidate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSwitchGroupsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSwitchGroupsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSwitchGroupsRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      tierId: isSet(object.tierId) ? globalThis.String(object.tierId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
    };
  },

  toJSON(message: GetSwitchGroupsRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSwitchGroupsRequest>, I>>(base?: I): GetSwitchGroupsRequest {
    return GetSwitchGroupsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSwitchGroupsRequest>, I>>(object: I): GetSwitchGroupsRequest {
    const message = createBaseGetSwitchGroupsRequest();
    message.fabricId = object.fabricId ?? "";
    message.tierId = object.tierId ?? "";
    message.candidate = object.candidate ?? "";
    return message;
  },
};

function createBaseGetSwitchGroupRequest(): GetSwitchGroupRequest {
  return { fabricId: "", tierId: "", groupId: "", candidate: "" };
}

export const GetSwitchGroupRequest: MessageFns<GetSwitchGroupRequest> = {
  encode(message: GetSwitchGroupRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.tierId !== "") {
      writer.uint32(18).string(message.tierId);
    }
    if (message.groupId !== "") {
      writer.uint32(26).string(message.groupId);
    }
    if (message.candidate !== "") {
      writer.uint32(34).string(message.candidate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSwitchGroupRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSwitchGroupRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.groupId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSwitchGroupRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      tierId: isSet(object.tierId) ? globalThis.String(object.tierId) : "",
      groupId: isSet(object.groupId) ? globalThis.String(object.groupId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
    };
  },

  toJSON(message: GetSwitchGroupRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.groupId !== "") {
      obj.groupId = message.groupId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSwitchGroupRequest>, I>>(base?: I): GetSwitchGroupRequest {
    return GetSwitchGroupRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSwitchGroupRequest>, I>>(object: I): GetSwitchGroupRequest {
    const message = createBaseGetSwitchGroupRequest();
    message.fabricId = object.fabricId ?? "";
    message.tierId = object.tierId ?? "";
    message.groupId = object.groupId ?? "";
    message.candidate = object.candidate ?? "";
    return message;
  },
};

function createBaseAddSwitchGroupsRequest(): AddSwitchGroupsRequest {
  return { fabricId: "", tierId: "", groups: [] };
}

export const AddSwitchGroupsRequest: MessageFns<AddSwitchGroupsRequest> = {
  encode(message: AddSwitchGroupsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.tierId !== "") {
      writer.uint32(18).string(message.tierId);
    }
    for (const v of message.groups) {
      SwitchGroup.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddSwitchGroupsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddSwitchGroupsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.groups.push(SwitchGroup.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddSwitchGroupsRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      tierId: isSet(object.tierId) ? globalThis.String(object.tierId) : "",
      groups: globalThis.Array.isArray(object?.groups) ? object.groups.map((e: any) => SwitchGroup.fromJSON(e)) : [],
    };
  },

  toJSON(message: AddSwitchGroupsRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.groups?.length) {
      obj.groups = message.groups.map((e) => SwitchGroup.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddSwitchGroupsRequest>, I>>(base?: I): AddSwitchGroupsRequest {
    return AddSwitchGroupsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddSwitchGroupsRequest>, I>>(object: I): AddSwitchGroupsRequest {
    const message = createBaseAddSwitchGroupsRequest();
    message.fabricId = object.fabricId ?? "";
    message.tierId = object.tierId ?? "";
    message.groups = object.groups?.map((e) => SwitchGroup.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpdateSwitchGroupRequest(): UpdateSwitchGroupRequest {
  return { fabricId: "", tierId: "", groupId: "", group: undefined };
}

export const UpdateSwitchGroupRequest: MessageFns<UpdateSwitchGroupRequest> = {
  encode(message: UpdateSwitchGroupRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.tierId !== "") {
      writer.uint32(18).string(message.tierId);
    }
    if (message.groupId !== "") {
      writer.uint32(26).string(message.groupId);
    }
    if (message.group !== undefined) {
      SwitchGroup.encode(message.group, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateSwitchGroupRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateSwitchGroupRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.groupId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.group = SwitchGroup.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateSwitchGroupRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      tierId: isSet(object.tierId) ? globalThis.String(object.tierId) : "",
      groupId: isSet(object.groupId) ? globalThis.String(object.groupId) : "",
      group: isSet(object.group) ? SwitchGroup.fromJSON(object.group) : undefined,
    };
  },

  toJSON(message: UpdateSwitchGroupRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.groupId !== "") {
      obj.groupId = message.groupId;
    }
    if (message.group !== undefined) {
      obj.group = SwitchGroup.toJSON(message.group);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateSwitchGroupRequest>, I>>(base?: I): UpdateSwitchGroupRequest {
    return UpdateSwitchGroupRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateSwitchGroupRequest>, I>>(object: I): UpdateSwitchGroupRequest {
    const message = createBaseUpdateSwitchGroupRequest();
    message.fabricId = object.fabricId ?? "";
    message.tierId = object.tierId ?? "";
    message.groupId = object.groupId ?? "";
    message.group = (object.group !== undefined && object.group !== null)
      ? SwitchGroup.fromPartial(object.group)
      : undefined;
    return message;
  },
};

function createBaseDeleteSwitchGroupRequest(): DeleteSwitchGroupRequest {
  return { fabricId: "", tierId: "", groupId: "" };
}

export const DeleteSwitchGroupRequest: MessageFns<DeleteSwitchGroupRequest> = {
  encode(message: DeleteSwitchGroupRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.tierId !== "") {
      writer.uint32(18).string(message.tierId);
    }
    if (message.groupId !== "") {
      writer.uint32(26).string(message.groupId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteSwitchGroupRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteSwitchGroupRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.groupId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteSwitchGroupRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      tierId: isSet(object.tierId) ? globalThis.String(object.tierId) : "",
      groupId: isSet(object.groupId) ? globalThis.String(object.groupId) : "",
    };
  },

  toJSON(message: DeleteSwitchGroupRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.groupId !== "") {
      obj.groupId = message.groupId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteSwitchGroupRequest>, I>>(base?: I): DeleteSwitchGroupRequest {
    return DeleteSwitchGroupRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteSwitchGroupRequest>, I>>(object: I): DeleteSwitchGroupRequest {
    const message = createBaseDeleteSwitchGroupRequest();
    message.fabricId = object.fabricId ?? "";
    message.tierId = object.tierId ?? "";
    message.groupId = object.groupId ?? "";
    return message;
  },
};

function createBaseSwitchGroupHardwareSetsResponse(): SwitchGroupHardwareSetsResponse {
  return { sets: [] };
}

export const SwitchGroupHardwareSetsResponse: MessageFns<SwitchGroupHardwareSetsResponse> = {
  encode(message: SwitchGroupHardwareSetsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.sets) {
      HwSet.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SwitchGroupHardwareSetsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSwitchGroupHardwareSetsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sets.push(HwSet.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SwitchGroupHardwareSetsResponse {
    return { sets: globalThis.Array.isArray(object?.sets) ? object.sets.map((e: any) => HwSet.fromJSON(e)) : [] };
  },

  toJSON(message: SwitchGroupHardwareSetsResponse): unknown {
    const obj: any = {};
    if (message.sets?.length) {
      obj.sets = message.sets.map((e) => HwSet.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SwitchGroupHardwareSetsResponse>, I>>(base?: I): SwitchGroupHardwareSetsResponse {
    return SwitchGroupHardwareSetsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SwitchGroupHardwareSetsResponse>, I>>(
    object: I,
  ): SwitchGroupHardwareSetsResponse {
    const message = createBaseSwitchGroupHardwareSetsResponse();
    message.sets = object.sets?.map((e) => HwSet.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetSwitchGroupHardwareSetsRequest(): GetSwitchGroupHardwareSetsRequest {
  return { fabricId: "", tierId: "", groupId: "", candidate: "" };
}

export const GetSwitchGroupHardwareSetsRequest: MessageFns<GetSwitchGroupHardwareSetsRequest> = {
  encode(message: GetSwitchGroupHardwareSetsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.tierId !== "") {
      writer.uint32(18).string(message.tierId);
    }
    if (message.groupId !== "") {
      writer.uint32(26).string(message.groupId);
    }
    if (message.candidate !== "") {
      writer.uint32(34).string(message.candidate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSwitchGroupHardwareSetsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSwitchGroupHardwareSetsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.groupId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSwitchGroupHardwareSetsRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      tierId: isSet(object.tierId) ? globalThis.String(object.tierId) : "",
      groupId: isSet(object.groupId) ? globalThis.String(object.groupId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
    };
  },

  toJSON(message: GetSwitchGroupHardwareSetsRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.groupId !== "") {
      obj.groupId = message.groupId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSwitchGroupHardwareSetsRequest>, I>>(
    base?: I,
  ): GetSwitchGroupHardwareSetsRequest {
    return GetSwitchGroupHardwareSetsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSwitchGroupHardwareSetsRequest>, I>>(
    object: I,
  ): GetSwitchGroupHardwareSetsRequest {
    const message = createBaseGetSwitchGroupHardwareSetsRequest();
    message.fabricId = object.fabricId ?? "";
    message.tierId = object.tierId ?? "";
    message.groupId = object.groupId ?? "";
    message.candidate = object.candidate ?? "";
    return message;
  },
};

function createBaseGetSwitchGroupHardwareSetRequest(): GetSwitchGroupHardwareSetRequest {
  return { fabricId: "", tierId: "", groupId: "", setId: "", candidate: "" };
}

export const GetSwitchGroupHardwareSetRequest: MessageFns<GetSwitchGroupHardwareSetRequest> = {
  encode(message: GetSwitchGroupHardwareSetRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.tierId !== "") {
      writer.uint32(18).string(message.tierId);
    }
    if (message.groupId !== "") {
      writer.uint32(26).string(message.groupId);
    }
    if (message.setId !== "") {
      writer.uint32(34).string(message.setId);
    }
    if (message.candidate !== "") {
      writer.uint32(42).string(message.candidate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSwitchGroupHardwareSetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSwitchGroupHardwareSetRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.groupId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.setId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSwitchGroupHardwareSetRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      tierId: isSet(object.tierId) ? globalThis.String(object.tierId) : "",
      groupId: isSet(object.groupId) ? globalThis.String(object.groupId) : "",
      setId: isSet(object.setId) ? globalThis.String(object.setId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
    };
  },

  toJSON(message: GetSwitchGroupHardwareSetRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.groupId !== "") {
      obj.groupId = message.groupId;
    }
    if (message.setId !== "") {
      obj.setId = message.setId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSwitchGroupHardwareSetRequest>, I>>(
    base?: I,
  ): GetSwitchGroupHardwareSetRequest {
    return GetSwitchGroupHardwareSetRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSwitchGroupHardwareSetRequest>, I>>(
    object: I,
  ): GetSwitchGroupHardwareSetRequest {
    const message = createBaseGetSwitchGroupHardwareSetRequest();
    message.fabricId = object.fabricId ?? "";
    message.tierId = object.tierId ?? "";
    message.groupId = object.groupId ?? "";
    message.setId = object.setId ?? "";
    message.candidate = object.candidate ?? "";
    return message;
  },
};

function createBaseAddSwitchGroupHardwareSetsRequest(): AddSwitchGroupHardwareSetsRequest {
  return { fabricId: "", tierId: "", groupId: "", sets: [] };
}

export const AddSwitchGroupHardwareSetsRequest: MessageFns<AddSwitchGroupHardwareSetsRequest> = {
  encode(message: AddSwitchGroupHardwareSetsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.tierId !== "") {
      writer.uint32(18).string(message.tierId);
    }
    if (message.groupId !== "") {
      writer.uint32(26).string(message.groupId);
    }
    for (const v of message.sets) {
      HwSet.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddSwitchGroupHardwareSetsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddSwitchGroupHardwareSetsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.groupId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.sets.push(HwSet.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddSwitchGroupHardwareSetsRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      tierId: isSet(object.tierId) ? globalThis.String(object.tierId) : "",
      groupId: isSet(object.groupId) ? globalThis.String(object.groupId) : "",
      sets: globalThis.Array.isArray(object?.sets) ? object.sets.map((e: any) => HwSet.fromJSON(e)) : [],
    };
  },

  toJSON(message: AddSwitchGroupHardwareSetsRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.groupId !== "") {
      obj.groupId = message.groupId;
    }
    if (message.sets?.length) {
      obj.sets = message.sets.map((e) => HwSet.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddSwitchGroupHardwareSetsRequest>, I>>(
    base?: I,
  ): AddSwitchGroupHardwareSetsRequest {
    return AddSwitchGroupHardwareSetsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddSwitchGroupHardwareSetsRequest>, I>>(
    object: I,
  ): AddSwitchGroupHardwareSetsRequest {
    const message = createBaseAddSwitchGroupHardwareSetsRequest();
    message.fabricId = object.fabricId ?? "";
    message.tierId = object.tierId ?? "";
    message.groupId = object.groupId ?? "";
    message.sets = object.sets?.map((e) => HwSet.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpdateSwitchGroupHardwareSetRequest(): UpdateSwitchGroupHardwareSetRequest {
  return { fabricId: "", tierId: "", groupId: "", setId: "", set: undefined };
}

export const UpdateSwitchGroupHardwareSetRequest: MessageFns<UpdateSwitchGroupHardwareSetRequest> = {
  encode(message: UpdateSwitchGroupHardwareSetRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.tierId !== "") {
      writer.uint32(18).string(message.tierId);
    }
    if (message.groupId !== "") {
      writer.uint32(26).string(message.groupId);
    }
    if (message.setId !== "") {
      writer.uint32(34).string(message.setId);
    }
    if (message.set !== undefined) {
      HwSet.encode(message.set, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateSwitchGroupHardwareSetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateSwitchGroupHardwareSetRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.groupId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.setId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.set = HwSet.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateSwitchGroupHardwareSetRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      tierId: isSet(object.tierId) ? globalThis.String(object.tierId) : "",
      groupId: isSet(object.groupId) ? globalThis.String(object.groupId) : "",
      setId: isSet(object.setId) ? globalThis.String(object.setId) : "",
      set: isSet(object.set) ? HwSet.fromJSON(object.set) : undefined,
    };
  },

  toJSON(message: UpdateSwitchGroupHardwareSetRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.groupId !== "") {
      obj.groupId = message.groupId;
    }
    if (message.setId !== "") {
      obj.setId = message.setId;
    }
    if (message.set !== undefined) {
      obj.set = HwSet.toJSON(message.set);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateSwitchGroupHardwareSetRequest>, I>>(
    base?: I,
  ): UpdateSwitchGroupHardwareSetRequest {
    return UpdateSwitchGroupHardwareSetRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateSwitchGroupHardwareSetRequest>, I>>(
    object: I,
  ): UpdateSwitchGroupHardwareSetRequest {
    const message = createBaseUpdateSwitchGroupHardwareSetRequest();
    message.fabricId = object.fabricId ?? "";
    message.tierId = object.tierId ?? "";
    message.groupId = object.groupId ?? "";
    message.setId = object.setId ?? "";
    message.set = (object.set !== undefined && object.set !== null) ? HwSet.fromPartial(object.set) : undefined;
    return message;
  },
};

function createBaseDeleteSwitchGroupHardwareSetRequest(): DeleteSwitchGroupHardwareSetRequest {
  return { fabricId: "", tierId: "", groupId: "", setId: "" };
}

export const DeleteSwitchGroupHardwareSetRequest: MessageFns<DeleteSwitchGroupHardwareSetRequest> = {
  encode(message: DeleteSwitchGroupHardwareSetRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.tierId !== "") {
      writer.uint32(18).string(message.tierId);
    }
    if (message.groupId !== "") {
      writer.uint32(26).string(message.groupId);
    }
    if (message.setId !== "") {
      writer.uint32(34).string(message.setId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteSwitchGroupHardwareSetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteSwitchGroupHardwareSetRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.groupId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.setId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteSwitchGroupHardwareSetRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      tierId: isSet(object.tierId) ? globalThis.String(object.tierId) : "",
      groupId: isSet(object.groupId) ? globalThis.String(object.groupId) : "",
      setId: isSet(object.setId) ? globalThis.String(object.setId) : "",
    };
  },

  toJSON(message: DeleteSwitchGroupHardwareSetRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.groupId !== "") {
      obj.groupId = message.groupId;
    }
    if (message.setId !== "") {
      obj.setId = message.setId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteSwitchGroupHardwareSetRequest>, I>>(
    base?: I,
  ): DeleteSwitchGroupHardwareSetRequest {
    return DeleteSwitchGroupHardwareSetRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteSwitchGroupHardwareSetRequest>, I>>(
    object: I,
  ): DeleteSwitchGroupHardwareSetRequest {
    const message = createBaseDeleteSwitchGroupHardwareSetRequest();
    message.fabricId = object.fabricId ?? "";
    message.tierId = object.tierId ?? "";
    message.groupId = object.groupId ?? "";
    message.setId = object.setId ?? "";
    return message;
  },
};

function createBaseServerGroupsResponse(): ServerGroupsResponse {
  return { fabricId: "", fabricName: "", tierId: "", tierName: "", groups: [] };
}

export const ServerGroupsResponse: MessageFns<ServerGroupsResponse> = {
  encode(message: ServerGroupsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.fabricName !== "") {
      writer.uint32(18).string(message.fabricName);
    }
    if (message.tierId !== "") {
      writer.uint32(26).string(message.tierId);
    }
    if (message.tierName !== "") {
      writer.uint32(34).string(message.tierName);
    }
    for (const v of message.groups) {
      ServerGroup.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerGroupsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerGroupsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.tierName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.groups.push(ServerGroup.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerGroupsResponse {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      fabricName: isSet(object.fabricName) ? globalThis.String(object.fabricName) : "",
      tierId: isSet(object.tierId) ? globalThis.String(object.tierId) : "",
      tierName: isSet(object.tierName) ? globalThis.String(object.tierName) : "",
      groups: globalThis.Array.isArray(object?.groups) ? object.groups.map((e: any) => ServerGroup.fromJSON(e)) : [],
    };
  },

  toJSON(message: ServerGroupsResponse): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.fabricName !== "") {
      obj.fabricName = message.fabricName;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.tierName !== "") {
      obj.tierName = message.tierName;
    }
    if (message.groups?.length) {
      obj.groups = message.groups.map((e) => ServerGroup.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerGroupsResponse>, I>>(base?: I): ServerGroupsResponse {
    return ServerGroupsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerGroupsResponse>, I>>(object: I): ServerGroupsResponse {
    const message = createBaseServerGroupsResponse();
    message.fabricId = object.fabricId ?? "";
    message.fabricName = object.fabricName ?? "";
    message.tierId = object.tierId ?? "";
    message.tierName = object.tierName ?? "";
    message.groups = object.groups?.map((e) => ServerGroup.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetServerGroupsRequest(): GetServerGroupsRequest {
  return { fabricId: "", tierId: "", candidate: "" };
}

export const GetServerGroupsRequest: MessageFns<GetServerGroupsRequest> = {
  encode(message: GetServerGroupsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.tierId !== "") {
      writer.uint32(18).string(message.tierId);
    }
    if (message.candidate !== "") {
      writer.uint32(26).string(message.candidate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetServerGroupsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetServerGroupsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetServerGroupsRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      tierId: isSet(object.tierId) ? globalThis.String(object.tierId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
    };
  },

  toJSON(message: GetServerGroupsRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetServerGroupsRequest>, I>>(base?: I): GetServerGroupsRequest {
    return GetServerGroupsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetServerGroupsRequest>, I>>(object: I): GetServerGroupsRequest {
    const message = createBaseGetServerGroupsRequest();
    message.fabricId = object.fabricId ?? "";
    message.tierId = object.tierId ?? "";
    message.candidate = object.candidate ?? "";
    return message;
  },
};

function createBaseGetServerGroupRequest(): GetServerGroupRequest {
  return { fabricId: "", tierId: "", groupId: "", candidate: "" };
}

export const GetServerGroupRequest: MessageFns<GetServerGroupRequest> = {
  encode(message: GetServerGroupRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.tierId !== "") {
      writer.uint32(18).string(message.tierId);
    }
    if (message.groupId !== "") {
      writer.uint32(26).string(message.groupId);
    }
    if (message.candidate !== "") {
      writer.uint32(34).string(message.candidate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetServerGroupRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetServerGroupRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.groupId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetServerGroupRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      tierId: isSet(object.tierId) ? globalThis.String(object.tierId) : "",
      groupId: isSet(object.groupId) ? globalThis.String(object.groupId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
    };
  },

  toJSON(message: GetServerGroupRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.groupId !== "") {
      obj.groupId = message.groupId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetServerGroupRequest>, I>>(base?: I): GetServerGroupRequest {
    return GetServerGroupRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetServerGroupRequest>, I>>(object: I): GetServerGroupRequest {
    const message = createBaseGetServerGroupRequest();
    message.fabricId = object.fabricId ?? "";
    message.tierId = object.tierId ?? "";
    message.groupId = object.groupId ?? "";
    message.candidate = object.candidate ?? "";
    return message;
  },
};

function createBaseAddServerGroupsRequest(): AddServerGroupsRequest {
  return { fabricId: "", tierId: "", groups: [] };
}

export const AddServerGroupsRequest: MessageFns<AddServerGroupsRequest> = {
  encode(message: AddServerGroupsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.tierId !== "") {
      writer.uint32(18).string(message.tierId);
    }
    for (const v of message.groups) {
      ServerGroup.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddServerGroupsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddServerGroupsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.groups.push(ServerGroup.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddServerGroupsRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      tierId: isSet(object.tierId) ? globalThis.String(object.tierId) : "",
      groups: globalThis.Array.isArray(object?.groups) ? object.groups.map((e: any) => ServerGroup.fromJSON(e)) : [],
    };
  },

  toJSON(message: AddServerGroupsRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.groups?.length) {
      obj.groups = message.groups.map((e) => ServerGroup.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddServerGroupsRequest>, I>>(base?: I): AddServerGroupsRequest {
    return AddServerGroupsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddServerGroupsRequest>, I>>(object: I): AddServerGroupsRequest {
    const message = createBaseAddServerGroupsRequest();
    message.fabricId = object.fabricId ?? "";
    message.tierId = object.tierId ?? "";
    message.groups = object.groups?.map((e) => ServerGroup.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpdateServerGroupRequest(): UpdateServerGroupRequest {
  return { fabricId: "", tierId: "", groupId: "", group: undefined };
}

export const UpdateServerGroupRequest: MessageFns<UpdateServerGroupRequest> = {
  encode(message: UpdateServerGroupRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.tierId !== "") {
      writer.uint32(18).string(message.tierId);
    }
    if (message.groupId !== "") {
      writer.uint32(26).string(message.groupId);
    }
    if (message.group !== undefined) {
      ServerGroup.encode(message.group, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateServerGroupRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateServerGroupRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.groupId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.group = ServerGroup.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateServerGroupRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      tierId: isSet(object.tierId) ? globalThis.String(object.tierId) : "",
      groupId: isSet(object.groupId) ? globalThis.String(object.groupId) : "",
      group: isSet(object.group) ? ServerGroup.fromJSON(object.group) : undefined,
    };
  },

  toJSON(message: UpdateServerGroupRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.groupId !== "") {
      obj.groupId = message.groupId;
    }
    if (message.group !== undefined) {
      obj.group = ServerGroup.toJSON(message.group);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateServerGroupRequest>, I>>(base?: I): UpdateServerGroupRequest {
    return UpdateServerGroupRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateServerGroupRequest>, I>>(object: I): UpdateServerGroupRequest {
    const message = createBaseUpdateServerGroupRequest();
    message.fabricId = object.fabricId ?? "";
    message.tierId = object.tierId ?? "";
    message.groupId = object.groupId ?? "";
    message.group = (object.group !== undefined && object.group !== null)
      ? ServerGroup.fromPartial(object.group)
      : undefined;
    return message;
  },
};

function createBaseDeleteServerGroupRequest(): DeleteServerGroupRequest {
  return { fabricId: "", tierId: "", groupId: "" };
}

export const DeleteServerGroupRequest: MessageFns<DeleteServerGroupRequest> = {
  encode(message: DeleteServerGroupRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.tierId !== "") {
      writer.uint32(18).string(message.tierId);
    }
    if (message.groupId !== "") {
      writer.uint32(26).string(message.groupId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteServerGroupRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteServerGroupRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.groupId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteServerGroupRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      tierId: isSet(object.tierId) ? globalThis.String(object.tierId) : "",
      groupId: isSet(object.groupId) ? globalThis.String(object.groupId) : "",
    };
  },

  toJSON(message: DeleteServerGroupRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.groupId !== "") {
      obj.groupId = message.groupId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteServerGroupRequest>, I>>(base?: I): DeleteServerGroupRequest {
    return DeleteServerGroupRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteServerGroupRequest>, I>>(object: I): DeleteServerGroupRequest {
    const message = createBaseDeleteServerGroupRequest();
    message.fabricId = object.fabricId ?? "";
    message.tierId = object.tierId ?? "";
    message.groupId = object.groupId ?? "";
    return message;
  },
};

function createBaseServerGroupHardwareSetsResponse(): ServerGroupHardwareSetsResponse {
  return { sets: [] };
}

export const ServerGroupHardwareSetsResponse: MessageFns<ServerGroupHardwareSetsResponse> = {
  encode(message: ServerGroupHardwareSetsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.sets) {
      HwSet.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerGroupHardwareSetsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerGroupHardwareSetsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sets.push(HwSet.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerGroupHardwareSetsResponse {
    return { sets: globalThis.Array.isArray(object?.sets) ? object.sets.map((e: any) => HwSet.fromJSON(e)) : [] };
  },

  toJSON(message: ServerGroupHardwareSetsResponse): unknown {
    const obj: any = {};
    if (message.sets?.length) {
      obj.sets = message.sets.map((e) => HwSet.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerGroupHardwareSetsResponse>, I>>(base?: I): ServerGroupHardwareSetsResponse {
    return ServerGroupHardwareSetsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerGroupHardwareSetsResponse>, I>>(
    object: I,
  ): ServerGroupHardwareSetsResponse {
    const message = createBaseServerGroupHardwareSetsResponse();
    message.sets = object.sets?.map((e) => HwSet.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetServerGroupHardwareSetsRequest(): GetServerGroupHardwareSetsRequest {
  return { fabricId: "", tierId: "", groupId: "", candidate: "" };
}

export const GetServerGroupHardwareSetsRequest: MessageFns<GetServerGroupHardwareSetsRequest> = {
  encode(message: GetServerGroupHardwareSetsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.tierId !== "") {
      writer.uint32(18).string(message.tierId);
    }
    if (message.groupId !== "") {
      writer.uint32(26).string(message.groupId);
    }
    if (message.candidate !== "") {
      writer.uint32(34).string(message.candidate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetServerGroupHardwareSetsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetServerGroupHardwareSetsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.groupId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetServerGroupHardwareSetsRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      tierId: isSet(object.tierId) ? globalThis.String(object.tierId) : "",
      groupId: isSet(object.groupId) ? globalThis.String(object.groupId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
    };
  },

  toJSON(message: GetServerGroupHardwareSetsRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.groupId !== "") {
      obj.groupId = message.groupId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetServerGroupHardwareSetsRequest>, I>>(
    base?: I,
  ): GetServerGroupHardwareSetsRequest {
    return GetServerGroupHardwareSetsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetServerGroupHardwareSetsRequest>, I>>(
    object: I,
  ): GetServerGroupHardwareSetsRequest {
    const message = createBaseGetServerGroupHardwareSetsRequest();
    message.fabricId = object.fabricId ?? "";
    message.tierId = object.tierId ?? "";
    message.groupId = object.groupId ?? "";
    message.candidate = object.candidate ?? "";
    return message;
  },
};

function createBaseGetServerGroupHardwareSetRequest(): GetServerGroupHardwareSetRequest {
  return { fabricId: "", tierId: "", groupId: "", setId: "", candidate: "" };
}

export const GetServerGroupHardwareSetRequest: MessageFns<GetServerGroupHardwareSetRequest> = {
  encode(message: GetServerGroupHardwareSetRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.tierId !== "") {
      writer.uint32(18).string(message.tierId);
    }
    if (message.groupId !== "") {
      writer.uint32(26).string(message.groupId);
    }
    if (message.setId !== "") {
      writer.uint32(34).string(message.setId);
    }
    if (message.candidate !== "") {
      writer.uint32(42).string(message.candidate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetServerGroupHardwareSetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetServerGroupHardwareSetRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.groupId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.setId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetServerGroupHardwareSetRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      tierId: isSet(object.tierId) ? globalThis.String(object.tierId) : "",
      groupId: isSet(object.groupId) ? globalThis.String(object.groupId) : "",
      setId: isSet(object.setId) ? globalThis.String(object.setId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
    };
  },

  toJSON(message: GetServerGroupHardwareSetRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.groupId !== "") {
      obj.groupId = message.groupId;
    }
    if (message.setId !== "") {
      obj.setId = message.setId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetServerGroupHardwareSetRequest>, I>>(
    base?: I,
  ): GetServerGroupHardwareSetRequest {
    return GetServerGroupHardwareSetRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetServerGroupHardwareSetRequest>, I>>(
    object: I,
  ): GetServerGroupHardwareSetRequest {
    const message = createBaseGetServerGroupHardwareSetRequest();
    message.fabricId = object.fabricId ?? "";
    message.tierId = object.tierId ?? "";
    message.groupId = object.groupId ?? "";
    message.setId = object.setId ?? "";
    message.candidate = object.candidate ?? "";
    return message;
  },
};

function createBaseAddServerGroupHardwareSetsRequest(): AddServerGroupHardwareSetsRequest {
  return { fabricId: "", tierId: "", groupId: "", sets: [] };
}

export const AddServerGroupHardwareSetsRequest: MessageFns<AddServerGroupHardwareSetsRequest> = {
  encode(message: AddServerGroupHardwareSetsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.tierId !== "") {
      writer.uint32(18).string(message.tierId);
    }
    if (message.groupId !== "") {
      writer.uint32(26).string(message.groupId);
    }
    for (const v of message.sets) {
      HwSet.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddServerGroupHardwareSetsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddServerGroupHardwareSetsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.groupId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.sets.push(HwSet.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddServerGroupHardwareSetsRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      tierId: isSet(object.tierId) ? globalThis.String(object.tierId) : "",
      groupId: isSet(object.groupId) ? globalThis.String(object.groupId) : "",
      sets: globalThis.Array.isArray(object?.sets) ? object.sets.map((e: any) => HwSet.fromJSON(e)) : [],
    };
  },

  toJSON(message: AddServerGroupHardwareSetsRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.groupId !== "") {
      obj.groupId = message.groupId;
    }
    if (message.sets?.length) {
      obj.sets = message.sets.map((e) => HwSet.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddServerGroupHardwareSetsRequest>, I>>(
    base?: I,
  ): AddServerGroupHardwareSetsRequest {
    return AddServerGroupHardwareSetsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddServerGroupHardwareSetsRequest>, I>>(
    object: I,
  ): AddServerGroupHardwareSetsRequest {
    const message = createBaseAddServerGroupHardwareSetsRequest();
    message.fabricId = object.fabricId ?? "";
    message.tierId = object.tierId ?? "";
    message.groupId = object.groupId ?? "";
    message.sets = object.sets?.map((e) => HwSet.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpdateServerGroupHardwareSetRequest(): UpdateServerGroupHardwareSetRequest {
  return { fabricId: "", tierId: "", groupId: "", setId: "", set: undefined };
}

export const UpdateServerGroupHardwareSetRequest: MessageFns<UpdateServerGroupHardwareSetRequest> = {
  encode(message: UpdateServerGroupHardwareSetRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.tierId !== "") {
      writer.uint32(18).string(message.tierId);
    }
    if (message.groupId !== "") {
      writer.uint32(26).string(message.groupId);
    }
    if (message.setId !== "") {
      writer.uint32(34).string(message.setId);
    }
    if (message.set !== undefined) {
      HwSet.encode(message.set, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateServerGroupHardwareSetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateServerGroupHardwareSetRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.groupId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.setId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.set = HwSet.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateServerGroupHardwareSetRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      tierId: isSet(object.tierId) ? globalThis.String(object.tierId) : "",
      groupId: isSet(object.groupId) ? globalThis.String(object.groupId) : "",
      setId: isSet(object.setId) ? globalThis.String(object.setId) : "",
      set: isSet(object.set) ? HwSet.fromJSON(object.set) : undefined,
    };
  },

  toJSON(message: UpdateServerGroupHardwareSetRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.groupId !== "") {
      obj.groupId = message.groupId;
    }
    if (message.setId !== "") {
      obj.setId = message.setId;
    }
    if (message.set !== undefined) {
      obj.set = HwSet.toJSON(message.set);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateServerGroupHardwareSetRequest>, I>>(
    base?: I,
  ): UpdateServerGroupHardwareSetRequest {
    return UpdateServerGroupHardwareSetRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateServerGroupHardwareSetRequest>, I>>(
    object: I,
  ): UpdateServerGroupHardwareSetRequest {
    const message = createBaseUpdateServerGroupHardwareSetRequest();
    message.fabricId = object.fabricId ?? "";
    message.tierId = object.tierId ?? "";
    message.groupId = object.groupId ?? "";
    message.setId = object.setId ?? "";
    message.set = (object.set !== undefined && object.set !== null) ? HwSet.fromPartial(object.set) : undefined;
    return message;
  },
};

function createBaseDeleteServerGroupHardwareSetRequest(): DeleteServerGroupHardwareSetRequest {
  return { fabricId: "", tierId: "", groupId: "", setId: "" };
}

export const DeleteServerGroupHardwareSetRequest: MessageFns<DeleteServerGroupHardwareSetRequest> = {
  encode(message: DeleteServerGroupHardwareSetRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.tierId !== "") {
      writer.uint32(18).string(message.tierId);
    }
    if (message.groupId !== "") {
      writer.uint32(26).string(message.groupId);
    }
    if (message.setId !== "") {
      writer.uint32(34).string(message.setId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteServerGroupHardwareSetRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteServerGroupHardwareSetRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.tierId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.groupId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.setId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteServerGroupHardwareSetRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      tierId: isSet(object.tierId) ? globalThis.String(object.tierId) : "",
      groupId: isSet(object.groupId) ? globalThis.String(object.groupId) : "",
      setId: isSet(object.setId) ? globalThis.String(object.setId) : "",
    };
  },

  toJSON(message: DeleteServerGroupHardwareSetRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.tierId !== "") {
      obj.tierId = message.tierId;
    }
    if (message.groupId !== "") {
      obj.groupId = message.groupId;
    }
    if (message.setId !== "") {
      obj.setId = message.setId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteServerGroupHardwareSetRequest>, I>>(
    base?: I,
  ): DeleteServerGroupHardwareSetRequest {
    return DeleteServerGroupHardwareSetRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteServerGroupHardwareSetRequest>, I>>(
    object: I,
  ): DeleteServerGroupHardwareSetRequest {
    const message = createBaseDeleteServerGroupHardwareSetRequest();
    message.fabricId = object.fabricId ?? "";
    message.tierId = object.tierId ?? "";
    message.groupId = object.groupId ?? "";
    message.setId = object.setId ?? "";
    return message;
  },
};

function createBaseRailGroupsResponse(): RailGroupsResponse {
  return { groups: [] };
}

export const RailGroupsResponse: MessageFns<RailGroupsResponse> = {
  encode(message: RailGroupsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.groups) {
      RailGroup.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RailGroupsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRailGroupsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.groups.push(RailGroup.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RailGroupsResponse {
    return {
      groups: globalThis.Array.isArray(object?.groups) ? object.groups.map((e: any) => RailGroup.fromJSON(e)) : [],
    };
  },

  toJSON(message: RailGroupsResponse): unknown {
    const obj: any = {};
    if (message.groups?.length) {
      obj.groups = message.groups.map((e) => RailGroup.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RailGroupsResponse>, I>>(base?: I): RailGroupsResponse {
    return RailGroupsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RailGroupsResponse>, I>>(object: I): RailGroupsResponse {
    const message = createBaseRailGroupsResponse();
    message.groups = object.groups?.map((e) => RailGroup.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetRailGroupsRequest(): GetRailGroupsRequest {
  return { fabricId: "", candidate: "" };
}

export const GetRailGroupsRequest: MessageFns<GetRailGroupsRequest> = {
  encode(message: GetRailGroupsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.candidate !== "") {
      writer.uint32(18).string(message.candidate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRailGroupsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRailGroupsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetRailGroupsRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
    };
  },

  toJSON(message: GetRailGroupsRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetRailGroupsRequest>, I>>(base?: I): GetRailGroupsRequest {
    return GetRailGroupsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetRailGroupsRequest>, I>>(object: I): GetRailGroupsRequest {
    const message = createBaseGetRailGroupsRequest();
    message.fabricId = object.fabricId ?? "";
    message.candidate = object.candidate ?? "";
    return message;
  },
};

function createBaseGetRailGroupRequest(): GetRailGroupRequest {
  return { fabricId: "", groupId: "", candidate: "" };
}

export const GetRailGroupRequest: MessageFns<GetRailGroupRequest> = {
  encode(message: GetRailGroupRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.groupId !== "") {
      writer.uint32(18).string(message.groupId);
    }
    if (message.candidate !== "") {
      writer.uint32(26).string(message.candidate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRailGroupRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRailGroupRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.groupId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetRailGroupRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      groupId: isSet(object.groupId) ? globalThis.String(object.groupId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
    };
  },

  toJSON(message: GetRailGroupRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.groupId !== "") {
      obj.groupId = message.groupId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetRailGroupRequest>, I>>(base?: I): GetRailGroupRequest {
    return GetRailGroupRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetRailGroupRequest>, I>>(object: I): GetRailGroupRequest {
    const message = createBaseGetRailGroupRequest();
    message.fabricId = object.fabricId ?? "";
    message.groupId = object.groupId ?? "";
    message.candidate = object.candidate ?? "";
    return message;
  },
};

function createBaseAddRailGroupsRequest(): AddRailGroupsRequest {
  return { fabricId: "", groups: [] };
}

export const AddRailGroupsRequest: MessageFns<AddRailGroupsRequest> = {
  encode(message: AddRailGroupsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    for (const v of message.groups) {
      RailGroup.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddRailGroupsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddRailGroupsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.groups.push(RailGroup.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddRailGroupsRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      groups: globalThis.Array.isArray(object?.groups) ? object.groups.map((e: any) => RailGroup.fromJSON(e)) : [],
    };
  },

  toJSON(message: AddRailGroupsRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.groups?.length) {
      obj.groups = message.groups.map((e) => RailGroup.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddRailGroupsRequest>, I>>(base?: I): AddRailGroupsRequest {
    return AddRailGroupsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddRailGroupsRequest>, I>>(object: I): AddRailGroupsRequest {
    const message = createBaseAddRailGroupsRequest();
    message.fabricId = object.fabricId ?? "";
    message.groups = object.groups?.map((e) => RailGroup.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpdateRailGroupRequest(): UpdateRailGroupRequest {
  return { fabricId: "", groupId: "", group: undefined };
}

export const UpdateRailGroupRequest: MessageFns<UpdateRailGroupRequest> = {
  encode(message: UpdateRailGroupRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.groupId !== "") {
      writer.uint32(18).string(message.groupId);
    }
    if (message.group !== undefined) {
      RailGroup.encode(message.group, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateRailGroupRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateRailGroupRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.groupId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.group = RailGroup.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateRailGroupRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      groupId: isSet(object.groupId) ? globalThis.String(object.groupId) : "",
      group: isSet(object.group) ? RailGroup.fromJSON(object.group) : undefined,
    };
  },

  toJSON(message: UpdateRailGroupRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.groupId !== "") {
      obj.groupId = message.groupId;
    }
    if (message.group !== undefined) {
      obj.group = RailGroup.toJSON(message.group);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateRailGroupRequest>, I>>(base?: I): UpdateRailGroupRequest {
    return UpdateRailGroupRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateRailGroupRequest>, I>>(object: I): UpdateRailGroupRequest {
    const message = createBaseUpdateRailGroupRequest();
    message.fabricId = object.fabricId ?? "";
    message.groupId = object.groupId ?? "";
    message.group = (object.group !== undefined && object.group !== null)
      ? RailGroup.fromPartial(object.group)
      : undefined;
    return message;
  },
};

function createBaseDeleteRailGroupRequest(): DeleteRailGroupRequest {
  return { fabricId: "", groupId: "" };
}

export const DeleteRailGroupRequest: MessageFns<DeleteRailGroupRequest> = {
  encode(message: DeleteRailGroupRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.groupId !== "") {
      writer.uint32(18).string(message.groupId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteRailGroupRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteRailGroupRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.groupId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteRailGroupRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      groupId: isSet(object.groupId) ? globalThis.String(object.groupId) : "",
    };
  },

  toJSON(message: DeleteRailGroupRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.groupId !== "") {
      obj.groupId = message.groupId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteRailGroupRequest>, I>>(base?: I): DeleteRailGroupRequest {
    return DeleteRailGroupRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteRailGroupRequest>, I>>(object: I): DeleteRailGroupRequest {
    const message = createBaseDeleteRailGroupRequest();
    message.fabricId = object.fabricId ?? "";
    message.groupId = object.groupId ?? "";
    return message;
  },
};

function createBaseServerGroupConnectivityRulesResponse(): ServerGroupConnectivityRulesResponse {
  return { rules: [] };
}

export const ServerGroupConnectivityRulesResponse: MessageFns<ServerGroupConnectivityRulesResponse> = {
  encode(message: ServerGroupConnectivityRulesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.rules) {
      ServerGroupConnectivityRule.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ServerGroupConnectivityRulesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerGroupConnectivityRulesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.rules.push(ServerGroupConnectivityRule.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerGroupConnectivityRulesResponse {
    return {
      rules: globalThis.Array.isArray(object?.rules)
        ? object.rules.map((e: any) => ServerGroupConnectivityRule.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ServerGroupConnectivityRulesResponse): unknown {
    const obj: any = {};
    if (message.rules?.length) {
      obj.rules = message.rules.map((e) => ServerGroupConnectivityRule.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerGroupConnectivityRulesResponse>, I>>(
    base?: I,
  ): ServerGroupConnectivityRulesResponse {
    return ServerGroupConnectivityRulesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerGroupConnectivityRulesResponse>, I>>(
    object: I,
  ): ServerGroupConnectivityRulesResponse {
    const message = createBaseServerGroupConnectivityRulesResponse();
    message.rules = object.rules?.map((e) => ServerGroupConnectivityRule.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetServerGroupConnectivityRulesRequest(): GetServerGroupConnectivityRulesRequest {
  return { fabricId: "", candidate: "" };
}

export const GetServerGroupConnectivityRulesRequest: MessageFns<GetServerGroupConnectivityRulesRequest> = {
  encode(message: GetServerGroupConnectivityRulesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.candidate !== "") {
      writer.uint32(18).string(message.candidate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetServerGroupConnectivityRulesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetServerGroupConnectivityRulesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetServerGroupConnectivityRulesRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
    };
  },

  toJSON(message: GetServerGroupConnectivityRulesRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetServerGroupConnectivityRulesRequest>, I>>(
    base?: I,
  ): GetServerGroupConnectivityRulesRequest {
    return GetServerGroupConnectivityRulesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetServerGroupConnectivityRulesRequest>, I>>(
    object: I,
  ): GetServerGroupConnectivityRulesRequest {
    const message = createBaseGetServerGroupConnectivityRulesRequest();
    message.fabricId = object.fabricId ?? "";
    message.candidate = object.candidate ?? "";
    return message;
  },
};

function createBaseGetServerGroupConnectivityRuleRequest(): GetServerGroupConnectivityRuleRequest {
  return { fabricId: "", ruleId: "", candidate: "" };
}

export const GetServerGroupConnectivityRuleRequest: MessageFns<GetServerGroupConnectivityRuleRequest> = {
  encode(message: GetServerGroupConnectivityRuleRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.ruleId !== "") {
      writer.uint32(18).string(message.ruleId);
    }
    if (message.candidate !== "") {
      writer.uint32(26).string(message.candidate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetServerGroupConnectivityRuleRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetServerGroupConnectivityRuleRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ruleId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetServerGroupConnectivityRuleRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      ruleId: isSet(object.ruleId) ? globalThis.String(object.ruleId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
    };
  },

  toJSON(message: GetServerGroupConnectivityRuleRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.ruleId !== "") {
      obj.ruleId = message.ruleId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetServerGroupConnectivityRuleRequest>, I>>(
    base?: I,
  ): GetServerGroupConnectivityRuleRequest {
    return GetServerGroupConnectivityRuleRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetServerGroupConnectivityRuleRequest>, I>>(
    object: I,
  ): GetServerGroupConnectivityRuleRequest {
    const message = createBaseGetServerGroupConnectivityRuleRequest();
    message.fabricId = object.fabricId ?? "";
    message.ruleId = object.ruleId ?? "";
    message.candidate = object.candidate ?? "";
    return message;
  },
};

function createBaseAddServerGroupConnectivityRulesRequest(): AddServerGroupConnectivityRulesRequest {
  return { fabricId: "", rules: [] };
}

export const AddServerGroupConnectivityRulesRequest: MessageFns<AddServerGroupConnectivityRulesRequest> = {
  encode(message: AddServerGroupConnectivityRulesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    for (const v of message.rules) {
      ServerGroupConnectivityRule.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddServerGroupConnectivityRulesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddServerGroupConnectivityRulesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.rules.push(ServerGroupConnectivityRule.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddServerGroupConnectivityRulesRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      rules: globalThis.Array.isArray(object?.rules)
        ? object.rules.map((e: any) => ServerGroupConnectivityRule.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AddServerGroupConnectivityRulesRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.rules?.length) {
      obj.rules = message.rules.map((e) => ServerGroupConnectivityRule.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddServerGroupConnectivityRulesRequest>, I>>(
    base?: I,
  ): AddServerGroupConnectivityRulesRequest {
    return AddServerGroupConnectivityRulesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddServerGroupConnectivityRulesRequest>, I>>(
    object: I,
  ): AddServerGroupConnectivityRulesRequest {
    const message = createBaseAddServerGroupConnectivityRulesRequest();
    message.fabricId = object.fabricId ?? "";
    message.rules = object.rules?.map((e) => ServerGroupConnectivityRule.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpdateServerGroupConnectivityRuleRequest(): UpdateServerGroupConnectivityRuleRequest {
  return { fabricId: "", ruleId: "", rule: undefined };
}

export const UpdateServerGroupConnectivityRuleRequest: MessageFns<UpdateServerGroupConnectivityRuleRequest> = {
  encode(message: UpdateServerGroupConnectivityRuleRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.ruleId !== "") {
      writer.uint32(18).string(message.ruleId);
    }
    if (message.rule !== undefined) {
      ServerGroupConnectivityRule.encode(message.rule, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateServerGroupConnectivityRuleRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateServerGroupConnectivityRuleRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ruleId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.rule = ServerGroupConnectivityRule.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateServerGroupConnectivityRuleRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      ruleId: isSet(object.ruleId) ? globalThis.String(object.ruleId) : "",
      rule: isSet(object.rule) ? ServerGroupConnectivityRule.fromJSON(object.rule) : undefined,
    };
  },

  toJSON(message: UpdateServerGroupConnectivityRuleRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.ruleId !== "") {
      obj.ruleId = message.ruleId;
    }
    if (message.rule !== undefined) {
      obj.rule = ServerGroupConnectivityRule.toJSON(message.rule);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateServerGroupConnectivityRuleRequest>, I>>(
    base?: I,
  ): UpdateServerGroupConnectivityRuleRequest {
    return UpdateServerGroupConnectivityRuleRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateServerGroupConnectivityRuleRequest>, I>>(
    object: I,
  ): UpdateServerGroupConnectivityRuleRequest {
    const message = createBaseUpdateServerGroupConnectivityRuleRequest();
    message.fabricId = object.fabricId ?? "";
    message.ruleId = object.ruleId ?? "";
    message.rule = (object.rule !== undefined && object.rule !== null)
      ? ServerGroupConnectivityRule.fromPartial(object.rule)
      : undefined;
    return message;
  },
};

function createBaseDeleteServerGroupConnectivityRuleRequest(): DeleteServerGroupConnectivityRuleRequest {
  return { fabricId: "", ruleId: "" };
}

export const DeleteServerGroupConnectivityRuleRequest: MessageFns<DeleteServerGroupConnectivityRuleRequest> = {
  encode(message: DeleteServerGroupConnectivityRuleRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.ruleId !== "") {
      writer.uint32(18).string(message.ruleId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteServerGroupConnectivityRuleRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteServerGroupConnectivityRuleRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ruleId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteServerGroupConnectivityRuleRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      ruleId: isSet(object.ruleId) ? globalThis.String(object.ruleId) : "",
    };
  },

  toJSON(message: DeleteServerGroupConnectivityRuleRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.ruleId !== "") {
      obj.ruleId = message.ruleId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteServerGroupConnectivityRuleRequest>, I>>(
    base?: I,
  ): DeleteServerGroupConnectivityRuleRequest {
    return DeleteServerGroupConnectivityRuleRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteServerGroupConnectivityRuleRequest>, I>>(
    object: I,
  ): DeleteServerGroupConnectivityRuleRequest {
    const message = createBaseDeleteServerGroupConnectivityRuleRequest();
    message.fabricId = object.fabricId ?? "";
    message.ruleId = object.ruleId ?? "";
    return message;
  },
};

function createBaseSwitchGroupConnectivityRulesResponse(): SwitchGroupConnectivityRulesResponse {
  return { rules: [] };
}

export const SwitchGroupConnectivityRulesResponse: MessageFns<SwitchGroupConnectivityRulesResponse> = {
  encode(message: SwitchGroupConnectivityRulesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.rules) {
      SwitchGroupConnectivityRule.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SwitchGroupConnectivityRulesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSwitchGroupConnectivityRulesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.rules.push(SwitchGroupConnectivityRule.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SwitchGroupConnectivityRulesResponse {
    return {
      rules: globalThis.Array.isArray(object?.rules)
        ? object.rules.map((e: any) => SwitchGroupConnectivityRule.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SwitchGroupConnectivityRulesResponse): unknown {
    const obj: any = {};
    if (message.rules?.length) {
      obj.rules = message.rules.map((e) => SwitchGroupConnectivityRule.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SwitchGroupConnectivityRulesResponse>, I>>(
    base?: I,
  ): SwitchGroupConnectivityRulesResponse {
    return SwitchGroupConnectivityRulesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SwitchGroupConnectivityRulesResponse>, I>>(
    object: I,
  ): SwitchGroupConnectivityRulesResponse {
    const message = createBaseSwitchGroupConnectivityRulesResponse();
    message.rules = object.rules?.map((e) => SwitchGroupConnectivityRule.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetSwitchGroupConnectivityRulesRequest(): GetSwitchGroupConnectivityRulesRequest {
  return { fabricId: "", candidate: "" };
}

export const GetSwitchGroupConnectivityRulesRequest: MessageFns<GetSwitchGroupConnectivityRulesRequest> = {
  encode(message: GetSwitchGroupConnectivityRulesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.candidate !== "") {
      writer.uint32(18).string(message.candidate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSwitchGroupConnectivityRulesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSwitchGroupConnectivityRulesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSwitchGroupConnectivityRulesRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
    };
  },

  toJSON(message: GetSwitchGroupConnectivityRulesRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSwitchGroupConnectivityRulesRequest>, I>>(
    base?: I,
  ): GetSwitchGroupConnectivityRulesRequest {
    return GetSwitchGroupConnectivityRulesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSwitchGroupConnectivityRulesRequest>, I>>(
    object: I,
  ): GetSwitchGroupConnectivityRulesRequest {
    const message = createBaseGetSwitchGroupConnectivityRulesRequest();
    message.fabricId = object.fabricId ?? "";
    message.candidate = object.candidate ?? "";
    return message;
  },
};

function createBaseGetSwitchGroupConnectivityRuleRequest(): GetSwitchGroupConnectivityRuleRequest {
  return { fabricId: "", ruleId: "", candidate: "" };
}

export const GetSwitchGroupConnectivityRuleRequest: MessageFns<GetSwitchGroupConnectivityRuleRequest> = {
  encode(message: GetSwitchGroupConnectivityRuleRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.ruleId !== "") {
      writer.uint32(18).string(message.ruleId);
    }
    if (message.candidate !== "") {
      writer.uint32(26).string(message.candidate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetSwitchGroupConnectivityRuleRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetSwitchGroupConnectivityRuleRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ruleId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetSwitchGroupConnectivityRuleRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      ruleId: isSet(object.ruleId) ? globalThis.String(object.ruleId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
    };
  },

  toJSON(message: GetSwitchGroupConnectivityRuleRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.ruleId !== "") {
      obj.ruleId = message.ruleId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetSwitchGroupConnectivityRuleRequest>, I>>(
    base?: I,
  ): GetSwitchGroupConnectivityRuleRequest {
    return GetSwitchGroupConnectivityRuleRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetSwitchGroupConnectivityRuleRequest>, I>>(
    object: I,
  ): GetSwitchGroupConnectivityRuleRequest {
    const message = createBaseGetSwitchGroupConnectivityRuleRequest();
    message.fabricId = object.fabricId ?? "";
    message.ruleId = object.ruleId ?? "";
    message.candidate = object.candidate ?? "";
    return message;
  },
};

function createBaseAddSwitchGroupConnectivityRulesRequest(): AddSwitchGroupConnectivityRulesRequest {
  return { fabricId: "", rules: [] };
}

export const AddSwitchGroupConnectivityRulesRequest: MessageFns<AddSwitchGroupConnectivityRulesRequest> = {
  encode(message: AddSwitchGroupConnectivityRulesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    for (const v of message.rules) {
      SwitchGroupConnectivityRule.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddSwitchGroupConnectivityRulesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddSwitchGroupConnectivityRulesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.rules.push(SwitchGroupConnectivityRule.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddSwitchGroupConnectivityRulesRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      rules: globalThis.Array.isArray(object?.rules)
        ? object.rules.map((e: any) => SwitchGroupConnectivityRule.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AddSwitchGroupConnectivityRulesRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.rules?.length) {
      obj.rules = message.rules.map((e) => SwitchGroupConnectivityRule.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddSwitchGroupConnectivityRulesRequest>, I>>(
    base?: I,
  ): AddSwitchGroupConnectivityRulesRequest {
    return AddSwitchGroupConnectivityRulesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddSwitchGroupConnectivityRulesRequest>, I>>(
    object: I,
  ): AddSwitchGroupConnectivityRulesRequest {
    const message = createBaseAddSwitchGroupConnectivityRulesRequest();
    message.fabricId = object.fabricId ?? "";
    message.rules = object.rules?.map((e) => SwitchGroupConnectivityRule.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpdateSwitchGroupConnectivityRuleRequest(): UpdateSwitchGroupConnectivityRuleRequest {
  return { fabricId: "", ruleId: "", rule: undefined };
}

export const UpdateSwitchGroupConnectivityRuleRequest: MessageFns<UpdateSwitchGroupConnectivityRuleRequest> = {
  encode(message: UpdateSwitchGroupConnectivityRuleRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.ruleId !== "") {
      writer.uint32(18).string(message.ruleId);
    }
    if (message.rule !== undefined) {
      SwitchGroupConnectivityRule.encode(message.rule, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateSwitchGroupConnectivityRuleRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateSwitchGroupConnectivityRuleRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ruleId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.rule = SwitchGroupConnectivityRule.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateSwitchGroupConnectivityRuleRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      ruleId: isSet(object.ruleId) ? globalThis.String(object.ruleId) : "",
      rule: isSet(object.rule) ? SwitchGroupConnectivityRule.fromJSON(object.rule) : undefined,
    };
  },

  toJSON(message: UpdateSwitchGroupConnectivityRuleRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.ruleId !== "") {
      obj.ruleId = message.ruleId;
    }
    if (message.rule !== undefined) {
      obj.rule = SwitchGroupConnectivityRule.toJSON(message.rule);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateSwitchGroupConnectivityRuleRequest>, I>>(
    base?: I,
  ): UpdateSwitchGroupConnectivityRuleRequest {
    return UpdateSwitchGroupConnectivityRuleRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateSwitchGroupConnectivityRuleRequest>, I>>(
    object: I,
  ): UpdateSwitchGroupConnectivityRuleRequest {
    const message = createBaseUpdateSwitchGroupConnectivityRuleRequest();
    message.fabricId = object.fabricId ?? "";
    message.ruleId = object.ruleId ?? "";
    message.rule = (object.rule !== undefined && object.rule !== null)
      ? SwitchGroupConnectivityRule.fromPartial(object.rule)
      : undefined;
    return message;
  },
};

function createBaseDeleteSwitchGroupConnectivityRuleRequest(): DeleteSwitchGroupConnectivityRuleRequest {
  return { fabricId: "", ruleId: "" };
}

export const DeleteSwitchGroupConnectivityRuleRequest: MessageFns<DeleteSwitchGroupConnectivityRuleRequest> = {
  encode(message: DeleteSwitchGroupConnectivityRuleRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.ruleId !== "") {
      writer.uint32(18).string(message.ruleId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteSwitchGroupConnectivityRuleRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteSwitchGroupConnectivityRuleRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ruleId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteSwitchGroupConnectivityRuleRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      ruleId: isSet(object.ruleId) ? globalThis.String(object.ruleId) : "",
    };
  },

  toJSON(message: DeleteSwitchGroupConnectivityRuleRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.ruleId !== "") {
      obj.ruleId = message.ruleId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteSwitchGroupConnectivityRuleRequest>, I>>(
    base?: I,
  ): DeleteSwitchGroupConnectivityRuleRequest {
    return DeleteSwitchGroupConnectivityRuleRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteSwitchGroupConnectivityRuleRequest>, I>>(
    object: I,
  ): DeleteSwitchGroupConnectivityRuleRequest {
    const message = createBaseDeleteSwitchGroupConnectivityRuleRequest();
    message.fabricId = object.fabricId ?? "";
    message.ruleId = object.ruleId ?? "";
    return message;
  },
};

function createBaseOverridesResponse(): OverridesResponse {
  return { rules: [] };
}

export const OverridesResponse: MessageFns<OverridesResponse> = {
  encode(message: OverridesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.rules) {
      NodePortConnectivityRule.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): OverridesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseOverridesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.rules.push(NodePortConnectivityRule.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): OverridesResponse {
    return {
      rules: globalThis.Array.isArray(object?.rules)
        ? object.rules.map((e: any) => NodePortConnectivityRule.fromJSON(e))
        : [],
    };
  },

  toJSON(message: OverridesResponse): unknown {
    const obj: any = {};
    if (message.rules?.length) {
      obj.rules = message.rules.map((e) => NodePortConnectivityRule.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OverridesResponse>, I>>(base?: I): OverridesResponse {
    return OverridesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OverridesResponse>, I>>(object: I): OverridesResponse {
    const message = createBaseOverridesResponse();
    message.rules = object.rules?.map((e) => NodePortConnectivityRule.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetOverridesRequest(): GetOverridesRequest {
  return { fabricId: "", candidate: "" };
}

export const GetOverridesRequest: MessageFns<GetOverridesRequest> = {
  encode(message: GetOverridesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.candidate !== "") {
      writer.uint32(18).string(message.candidate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetOverridesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOverridesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOverridesRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
    };
  },

  toJSON(message: GetOverridesRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOverridesRequest>, I>>(base?: I): GetOverridesRequest {
    return GetOverridesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOverridesRequest>, I>>(object: I): GetOverridesRequest {
    const message = createBaseGetOverridesRequest();
    message.fabricId = object.fabricId ?? "";
    message.candidate = object.candidate ?? "";
    return message;
  },
};

function createBaseGetConnectionOverrideRequest(): GetConnectionOverrideRequest {
  return { fabricId: "", ruleId: "", candidate: "" };
}

export const GetConnectionOverrideRequest: MessageFns<GetConnectionOverrideRequest> = {
  encode(message: GetConnectionOverrideRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.ruleId !== "") {
      writer.uint32(18).string(message.ruleId);
    }
    if (message.candidate !== "") {
      writer.uint32(26).string(message.candidate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetConnectionOverrideRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetConnectionOverrideRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ruleId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetConnectionOverrideRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      ruleId: isSet(object.ruleId) ? globalThis.String(object.ruleId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
    };
  },

  toJSON(message: GetConnectionOverrideRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.ruleId !== "") {
      obj.ruleId = message.ruleId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetConnectionOverrideRequest>, I>>(base?: I): GetConnectionOverrideRequest {
    return GetConnectionOverrideRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetConnectionOverrideRequest>, I>>(object: I): GetConnectionOverrideRequest {
    const message = createBaseGetConnectionOverrideRequest();
    message.fabricId = object.fabricId ?? "";
    message.ruleId = object.ruleId ?? "";
    message.candidate = object.candidate ?? "";
    return message;
  },
};

function createBaseAddConnectionOverridesRequest(): AddConnectionOverridesRequest {
  return { fabricId: "", rules: [] };
}

export const AddConnectionOverridesRequest: MessageFns<AddConnectionOverridesRequest> = {
  encode(message: AddConnectionOverridesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    for (const v of message.rules) {
      NodePortConnectivityRule.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddConnectionOverridesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddConnectionOverridesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.rules.push(NodePortConnectivityRule.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddConnectionOverridesRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      rules: globalThis.Array.isArray(object?.rules)
        ? object.rules.map((e: any) => NodePortConnectivityRule.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AddConnectionOverridesRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.rules?.length) {
      obj.rules = message.rules.map((e) => NodePortConnectivityRule.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddConnectionOverridesRequest>, I>>(base?: I): AddConnectionOverridesRequest {
    return AddConnectionOverridesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddConnectionOverridesRequest>, I>>(
    object: I,
  ): AddConnectionOverridesRequest {
    const message = createBaseAddConnectionOverridesRequest();
    message.fabricId = object.fabricId ?? "";
    message.rules = object.rules?.map((e) => NodePortConnectivityRule.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpdateConnectionOverrideRequest(): UpdateConnectionOverrideRequest {
  return { fabricId: "", ruleId: "", rule: undefined };
}

export const UpdateConnectionOverrideRequest: MessageFns<UpdateConnectionOverrideRequest> = {
  encode(message: UpdateConnectionOverrideRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.ruleId !== "") {
      writer.uint32(18).string(message.ruleId);
    }
    if (message.rule !== undefined) {
      NodePortConnectivityRule.encode(message.rule, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateConnectionOverrideRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateConnectionOverrideRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ruleId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.rule = NodePortConnectivityRule.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateConnectionOverrideRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      ruleId: isSet(object.ruleId) ? globalThis.String(object.ruleId) : "",
      rule: isSet(object.rule) ? NodePortConnectivityRule.fromJSON(object.rule) : undefined,
    };
  },

  toJSON(message: UpdateConnectionOverrideRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.ruleId !== "") {
      obj.ruleId = message.ruleId;
    }
    if (message.rule !== undefined) {
      obj.rule = NodePortConnectivityRule.toJSON(message.rule);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateConnectionOverrideRequest>, I>>(base?: I): UpdateConnectionOverrideRequest {
    return UpdateConnectionOverrideRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateConnectionOverrideRequest>, I>>(
    object: I,
  ): UpdateConnectionOverrideRequest {
    const message = createBaseUpdateConnectionOverrideRequest();
    message.fabricId = object.fabricId ?? "";
    message.ruleId = object.ruleId ?? "";
    message.rule = (object.rule !== undefined && object.rule !== null)
      ? NodePortConnectivityRule.fromPartial(object.rule)
      : undefined;
    return message;
  },
};

function createBaseDeleteConnectionOverrideRequest(): DeleteConnectionOverrideRequest {
  return { fabricId: "", ruleId: "" };
}

export const DeleteConnectionOverrideRequest: MessageFns<DeleteConnectionOverrideRequest> = {
  encode(message: DeleteConnectionOverrideRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.ruleId !== "") {
      writer.uint32(18).string(message.ruleId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteConnectionOverrideRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteConnectionOverrideRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ruleId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteConnectionOverrideRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      ruleId: isSet(object.ruleId) ? globalThis.String(object.ruleId) : "",
    };
  },

  toJSON(message: DeleteConnectionOverrideRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.ruleId !== "") {
      obj.ruleId = message.ruleId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteConnectionOverrideRequest>, I>>(base?: I): DeleteConnectionOverrideRequest {
    return DeleteConnectionOverrideRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteConnectionOverrideRequest>, I>>(
    object: I,
  ): DeleteConnectionOverrideRequest {
    const message = createBaseDeleteConnectionOverrideRequest();
    message.fabricId = object.fabricId ?? "";
    message.ruleId = object.ruleId ?? "";
    return message;
  },
};

function createBasePortReservationsResponse(): PortReservationsResponse {
  return { rules: [] };
}

export const PortReservationsResponse: MessageFns<PortReservationsResponse> = {
  encode(message: PortReservationsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.rules) {
      NodePortOverrideRule.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortReservationsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePortReservationsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.rules.push(NodePortOverrideRule.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PortReservationsResponse {
    return {
      rules: globalThis.Array.isArray(object?.rules)
        ? object.rules.map((e: any) => NodePortOverrideRule.fromJSON(e))
        : [],
    };
  },

  toJSON(message: PortReservationsResponse): unknown {
    const obj: any = {};
    if (message.rules?.length) {
      obj.rules = message.rules.map((e) => NodePortOverrideRule.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PortReservationsResponse>, I>>(base?: I): PortReservationsResponse {
    return PortReservationsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PortReservationsResponse>, I>>(object: I): PortReservationsResponse {
    const message = createBasePortReservationsResponse();
    message.rules = object.rules?.map((e) => NodePortOverrideRule.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetPortReservationsRequest(): GetPortReservationsRequest {
  return { fabricId: "", candidate: "" };
}

export const GetPortReservationsRequest: MessageFns<GetPortReservationsRequest> = {
  encode(message: GetPortReservationsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.candidate !== "") {
      writer.uint32(18).string(message.candidate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPortReservationsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPortReservationsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPortReservationsRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
    };
  },

  toJSON(message: GetPortReservationsRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPortReservationsRequest>, I>>(base?: I): GetPortReservationsRequest {
    return GetPortReservationsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPortReservationsRequest>, I>>(object: I): GetPortReservationsRequest {
    const message = createBaseGetPortReservationsRequest();
    message.fabricId = object.fabricId ?? "";
    message.candidate = object.candidate ?? "";
    return message;
  },
};

function createBaseGetPortReservationRequest(): GetPortReservationRequest {
  return { fabricId: "", ruleId: "", candidate: "" };
}

export const GetPortReservationRequest: MessageFns<GetPortReservationRequest> = {
  encode(message: GetPortReservationRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.ruleId !== "") {
      writer.uint32(18).string(message.ruleId);
    }
    if (message.candidate !== "") {
      writer.uint32(26).string(message.candidate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPortReservationRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPortReservationRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ruleId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPortReservationRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      ruleId: isSet(object.ruleId) ? globalThis.String(object.ruleId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
    };
  },

  toJSON(message: GetPortReservationRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.ruleId !== "") {
      obj.ruleId = message.ruleId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPortReservationRequest>, I>>(base?: I): GetPortReservationRequest {
    return GetPortReservationRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPortReservationRequest>, I>>(object: I): GetPortReservationRequest {
    const message = createBaseGetPortReservationRequest();
    message.fabricId = object.fabricId ?? "";
    message.ruleId = object.ruleId ?? "";
    message.candidate = object.candidate ?? "";
    return message;
  },
};

function createBaseAddPortReservationsRequest(): AddPortReservationsRequest {
  return { fabricId: "", rules: [] };
}

export const AddPortReservationsRequest: MessageFns<AddPortReservationsRequest> = {
  encode(message: AddPortReservationsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    for (const v of message.rules) {
      NodePortOverrideRule.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddPortReservationsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddPortReservationsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.rules.push(NodePortOverrideRule.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddPortReservationsRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      rules: globalThis.Array.isArray(object?.rules)
        ? object.rules.map((e: any) => NodePortOverrideRule.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AddPortReservationsRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.rules?.length) {
      obj.rules = message.rules.map((e) => NodePortOverrideRule.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddPortReservationsRequest>, I>>(base?: I): AddPortReservationsRequest {
    return AddPortReservationsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddPortReservationsRequest>, I>>(object: I): AddPortReservationsRequest {
    const message = createBaseAddPortReservationsRequest();
    message.fabricId = object.fabricId ?? "";
    message.rules = object.rules?.map((e) => NodePortOverrideRule.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpdatePortReservationRequest(): UpdatePortReservationRequest {
  return { fabricId: "", ruleId: "", rule: undefined };
}

export const UpdatePortReservationRequest: MessageFns<UpdatePortReservationRequest> = {
  encode(message: UpdatePortReservationRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.ruleId !== "") {
      writer.uint32(18).string(message.ruleId);
    }
    if (message.rule !== undefined) {
      NodePortOverrideRule.encode(message.rule, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdatePortReservationRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdatePortReservationRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ruleId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.rule = NodePortOverrideRule.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdatePortReservationRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      ruleId: isSet(object.ruleId) ? globalThis.String(object.ruleId) : "",
      rule: isSet(object.rule) ? NodePortOverrideRule.fromJSON(object.rule) : undefined,
    };
  },

  toJSON(message: UpdatePortReservationRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.ruleId !== "") {
      obj.ruleId = message.ruleId;
    }
    if (message.rule !== undefined) {
      obj.rule = NodePortOverrideRule.toJSON(message.rule);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdatePortReservationRequest>, I>>(base?: I): UpdatePortReservationRequest {
    return UpdatePortReservationRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdatePortReservationRequest>, I>>(object: I): UpdatePortReservationRequest {
    const message = createBaseUpdatePortReservationRequest();
    message.fabricId = object.fabricId ?? "";
    message.ruleId = object.ruleId ?? "";
    message.rule = (object.rule !== undefined && object.rule !== null)
      ? NodePortOverrideRule.fromPartial(object.rule)
      : undefined;
    return message;
  },
};

function createBaseDeletePortReservationRequest(): DeletePortReservationRequest {
  return { fabricId: "", ruleId: "" };
}

export const DeletePortReservationRequest: MessageFns<DeletePortReservationRequest> = {
  encode(message: DeletePortReservationRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.ruleId !== "") {
      writer.uint32(18).string(message.ruleId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeletePortReservationRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeletePortReservationRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.ruleId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeletePortReservationRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      ruleId: isSet(object.ruleId) ? globalThis.String(object.ruleId) : "",
    };
  },

  toJSON(message: DeletePortReservationRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.ruleId !== "") {
      obj.ruleId = message.ruleId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeletePortReservationRequest>, I>>(base?: I): DeletePortReservationRequest {
    return DeletePortReservationRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeletePortReservationRequest>, I>>(object: I): DeletePortReservationRequest {
    const message = createBaseDeletePortReservationRequest();
    message.fabricId = object.fabricId ?? "";
    message.ruleId = object.ruleId ?? "";
    return message;
  },
};

function createBaseMergeTopologyIntoFabricDesignRequest(): MergeTopologyIntoFabricDesignRequest {
  return { fabricId: "", design: undefined, topology: undefined, fabricName: "" };
}

export const MergeTopologyIntoFabricDesignRequest: MessageFns<MergeTopologyIntoFabricDesignRequest> = {
  encode(message: MergeTopologyIntoFabricDesignRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.design !== undefined) {
      FabricDesign.encode(message.design, writer.uint32(18).fork()).join();
    }
    if (message.topology !== undefined) {
      DiscoveredTopology.encode(message.topology, writer.uint32(26).fork()).join();
    }
    if (message.fabricName !== "") {
      writer.uint32(34).string(message.fabricName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MergeTopologyIntoFabricDesignRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMergeTopologyIntoFabricDesignRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.design = FabricDesign.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.topology = DiscoveredTopology.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.fabricName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MergeTopologyIntoFabricDesignRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      design: isSet(object.design) ? FabricDesign.fromJSON(object.design) : undefined,
      topology: isSet(object.topology) ? DiscoveredTopology.fromJSON(object.topology) : undefined,
      fabricName: isSet(object.fabricName) ? globalThis.String(object.fabricName) : "",
    };
  },

  toJSON(message: MergeTopologyIntoFabricDesignRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.design !== undefined) {
      obj.design = FabricDesign.toJSON(message.design);
    }
    if (message.topology !== undefined) {
      obj.topology = DiscoveredTopology.toJSON(message.topology);
    }
    if (message.fabricName !== "") {
      obj.fabricName = message.fabricName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MergeTopologyIntoFabricDesignRequest>, I>>(
    base?: I,
  ): MergeTopologyIntoFabricDesignRequest {
    return MergeTopologyIntoFabricDesignRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MergeTopologyIntoFabricDesignRequest>, I>>(
    object: I,
  ): MergeTopologyIntoFabricDesignRequest {
    const message = createBaseMergeTopologyIntoFabricDesignRequest();
    message.fabricId = object.fabricId ?? "";
    message.design = (object.design !== undefined && object.design !== null)
      ? FabricDesign.fromPartial(object.design)
      : undefined;
    message.topology = (object.topology !== undefined && object.topology !== null)
      ? DiscoveredTopology.fromPartial(object.topology)
      : undefined;
    message.fabricName = object.fabricName ?? "";
    return message;
  },
};

function createBaseMergeTopologyIntoFabricDesignResponse(): MergeTopologyIntoFabricDesignResponse {
  return { design: undefined, discoveredNodeDeviceBindings: [] };
}

export const MergeTopologyIntoFabricDesignResponse: MessageFns<MergeTopologyIntoFabricDesignResponse> = {
  encode(message: MergeTopologyIntoFabricDesignResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.design !== undefined) {
      FabricDesign.encode(message.design, writer.uint32(10).fork()).join();
    }
    for (const v of message.discoveredNodeDeviceBindings) {
      DesignNodeData.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MergeTopologyIntoFabricDesignResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMergeTopologyIntoFabricDesignResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.design = FabricDesign.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.discoveredNodeDeviceBindings.push(DesignNodeData.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MergeTopologyIntoFabricDesignResponse {
    return {
      design: isSet(object.design) ? FabricDesign.fromJSON(object.design) : undefined,
      discoveredNodeDeviceBindings: globalThis.Array.isArray(object?.discoveredNodeDeviceBindings)
        ? object.discoveredNodeDeviceBindings.map((e: any) => DesignNodeData.fromJSON(e))
        : [],
    };
  },

  toJSON(message: MergeTopologyIntoFabricDesignResponse): unknown {
    const obj: any = {};
    if (message.design !== undefined) {
      obj.design = FabricDesign.toJSON(message.design);
    }
    if (message.discoveredNodeDeviceBindings?.length) {
      obj.discoveredNodeDeviceBindings = message.discoveredNodeDeviceBindings.map((e) => DesignNodeData.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MergeTopologyIntoFabricDesignResponse>, I>>(
    base?: I,
  ): MergeTopologyIntoFabricDesignResponse {
    return MergeTopologyIntoFabricDesignResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MergeTopologyIntoFabricDesignResponse>, I>>(
    object: I,
  ): MergeTopologyIntoFabricDesignResponse {
    const message = createBaseMergeTopologyIntoFabricDesignResponse();
    message.design = (object.design !== undefined && object.design !== null)
      ? FabricDesign.fromPartial(object.design)
      : undefined;
    message.discoveredNodeDeviceBindings =
      object.discoveredNodeDeviceBindings?.map((e) => DesignNodeData.fromPartial(e)) || [];
    return message;
  },
};

function createBaseResolveTopologyRequest(): ResolveTopologyRequest {
  return { fabricId: "", design: undefined };
}

export const ResolveTopologyRequest: MessageFns<ResolveTopologyRequest> = {
  encode(message: ResolveTopologyRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.design !== undefined) {
      FabricDesign.encode(message.design, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResolveTopologyRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResolveTopologyRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.design = FabricDesign.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ResolveTopologyRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      design: isSet(object.design) ? FabricDesign.fromJSON(object.design) : undefined,
    };
  },

  toJSON(message: ResolveTopologyRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.design !== undefined) {
      obj.design = FabricDesign.toJSON(message.design);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ResolveTopologyRequest>, I>>(base?: I): ResolveTopologyRequest {
    return ResolveTopologyRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ResolveTopologyRequest>, I>>(object: I): ResolveTopologyRequest {
    const message = createBaseResolveTopologyRequest();
    message.fabricId = object.fabricId ?? "";
    message.design = (object.design !== undefined && object.design !== null)
      ? FabricDesign.fromPartial(object.design)
      : undefined;
    return message;
  },
};

function createBaseResolveTopologyResponse(): ResolveTopologyResponse {
  return { topology: undefined };
}

export const ResolveTopologyResponse: MessageFns<ResolveTopologyResponse> = {
  encode(message: ResolveTopologyResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.topology !== undefined) {
      DiscoveredTopology.encode(message.topology, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResolveTopologyResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResolveTopologyResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.topology = DiscoveredTopology.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ResolveTopologyResponse {
    return { topology: isSet(object.topology) ? DiscoveredTopology.fromJSON(object.topology) : undefined };
  },

  toJSON(message: ResolveTopologyResponse): unknown {
    const obj: any = {};
    if (message.topology !== undefined) {
      obj.topology = DiscoveredTopology.toJSON(message.topology);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ResolveTopologyResponse>, I>>(base?: I): ResolveTopologyResponse {
    return ResolveTopologyResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ResolveTopologyResponse>, I>>(object: I): ResolveTopologyResponse {
    const message = createBaseResolveTopologyResponse();
    message.topology = (object.topology !== undefined && object.topology !== null)
      ? DiscoveredTopology.fromPartial(object.topology)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
